import { render, staticRenderFns } from "./DotNav.vue?vue&type=template&id=1dcb8a8a&"
import script from "./DotNav.vue?vue&type=script&lang=js&"
export * from "./DotNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports